import { api } from '@/lib/api';
import type { GalleryPhoto, GalleryPhotoType } from './types';

const URL = '/vendor/photos';

export async function fetch_gallery_photos(): Promise<GalleryPhoto[]> {
  const res = await api.get<GalleryPhoto[]>(URL);
  return res.data;
}

/** Returns the vendor's whole gallery after the upload. */
export async function upload_gallery_photo(
  type: GalleryPhotoType,
  file: File,
): Promise<GalleryPhoto[]> {
  const form = new FormData();
  form.append('type', type);
  form.append('file', file);
  const res = await api.post<GalleryPhoto[]>(URL, form);
  return res.data;
}

export async function delete_gallery_photo(id: string): Promise<void> {
  await api.delete(`${URL}/${id}`);
}
